import { GameIds } from '../my-games/MyGames.model';

export enum PromotionStatus {
  Claimed = 'claimed',
  Claimable = 'claimable',
  InProgress = 'inProgress',
}

export interface Reward {
  displayName: string;
  pictureURL: string;
  gameSpecificData: {
    universalStatus: string;
    rarity: string;
  };
}

export enum RewardDeliveryType {
  Promocode = 'PROMOCODE',
  Direct = 'DIRECT',
}

export interface PromotionData {
  promotionId: string;
  relatedToGameId: string;
  requiredGameIds?: GameIds[];
  redeemableOnPlatformIds: string[];
  rewardDeliveryType: RewardDeliveryType;
  rewards: Reward[];
}

export interface UserData {
  status: PromotionStatus;
  promocode: { code: string };
}
export interface Promotion {
  promotionData: PromotionData;
  userData?: UserData;
}

export interface GamePromotions {
  requiredGameId: string;
  promotions: Promotion[];
}
